import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileDownload.tsx
const IconFileDownload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M13 12h3l-4 4-4-4h3V8h2zm2-8H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008z"
	})]
});
var IconFileDownload_default = forwardRef(IconFileDownload);
//#endregion
export { IconFileDownload_default as default };
